import { h, t, T, domWithScope } from '@jsx6/jsx6'

/**
 * 
 * @param {ChatBox} chat 
 * @returns 
 */
export const incomingCallModal = chat => {
  return (
    <div p="modal" id="modal" class="modal-dialog" hidden>
      <div class="modal-content">
        <div class="call-animation">
          <span p="incomingCallIcon" icon="agent"></span>
        </div>
        <div p="modal_content">{T`incoming_call`}</div>
        <div p="modal_buttons" class="buttons-line">
          <button p="modal_bt.ok" onclick={e => chat.acceptCall()} icon="phone"></button>
          <button p="modal_bt.cancel" onclick={e => chat.callFinished(true, false)} icon="call-end"></button>
        </div>
      </div>
    </div>
  )
}
